import { PsValueHolder } from '@/object/core/PsValueHolder';

export class PsValueProvider {

    static psValueHolder = new PsValueHolder();    

}

